'use strict';

angular.module('webAgro1App').controller('UsoMaquinaCtrl', function($uibModalInstance, data, LoadingService, PrestacaoServicos, MessagesService) {
  this.data = data;

  this.init = () => {
    LoadingService.showLoading();

    PrestacaoServicos.list({
      maquina_id: this.data.maquinaId,
      data_inicial: this.data.date,
      data_final: this.data.date
    }).then((result) => {
      this.usos = result.data;
    }, (error) => {
      console.error('Falha ao recuperar usos de máquina', error);
      MessagesService.alert('Falha ao recuperar usos de máquina');
    }).finally(() => {
      this.ready = true;
      LoadingService.hideLoading();
    });
  };

  this.close = () => {
    $uibModalInstance.dismiss('cancel');
  };

  this.init();
});
